import { styled as muiStyled } from '@mui/material';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import Collapse from '@mui/material/Collapse';
import { NEW_COLORS } from '../../themes/colors/newColors';

export const Wrapper = muiStyled(Stack)(() => ({
  border: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
  borderRadius: '8px 8px 8px 8px',
  transition: 'background-color 0.3s ease-in-out',
}));

export const Header = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  cursor: 'pointer',
  padding: '16px',
}));

export const StyledCollapse = muiStyled(Collapse)(() => ({
  borderRadius: '0 0 8px 8px',
  boxShadow: '0px 16px 24px rgba(0, 0, 0, 0.06)',
  background: NEW_COLORS.GRAYSCALE[50],
}));

export const FieldWrapper = muiStyled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const FilterButton = muiStyled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  background: NEW_COLORS.PRIMARY[500],
  border: `1px solid ${NEW_COLORS.SUPPORT.INDIGO[400]}`,
  borderRadius: '4px',
  padding: '6px',
  marginRight: '8px',
  cursor: 'default',

  '& .MuiTypography-root': {
    marginRight: '8px',
    fontWeight: 400,
    fontSize: '12px',
    color: NEW_COLORS.BASE.WHITE,
  },
}));

export const Calendar = muiStyled(Stack)(() => ({
  '&&': {
    borderRadius: '0 0 8px 8px',
    boxShadow: '0px 16px 24px rgba(0, 0, 0, 0.06)',
    backgroundColor: NEW_COLORS.GRAYSCALE[50],
    border: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
  },
}));
